<template>
  <div class="rounded-md border border-mid-neutral-50">
    <div
      class="flex justify-between items-center px-5 py-4 bg-[#F9FAFC] border-b border-mid-neutral-50 rounded-t-md"
    >
      <div>
        <h2 class="text-lg font-semibold text-dark-neutral-900">
          {{ title }}
        </h2>
        <p class="text-sm font-normal text-slate-500">{{ subtitle }}</p>
      </div>
      <slot name="header-button" />
    </div>

    <div v-if="displayContent" class="p-5">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    title?: string;
    subtitle?: string;
    displayContent?: boolean;
  }>(),
  {
    title: "",
    subtitle: "",
    displayContent: true,
  },
);
</script>
